
import { Component, Mixins } from "vue-property-decorator";
import { TextureStylePropertyEditableMixin } from "../../../mixins";
import { default as ShapeObjectDrawerBase } from "./ShapeObjectDrawerBase.vue";

@Component
export default class TexturedShapeObjectDrawerBase extends Mixins(ShapeObjectDrawerBase, TextureStylePropertyEditableMixin) {
}
